<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('footer.codeOfConduct')" :heroSubtitle="$t('ccPage.subtitle')" />

    <section class="jsk-block pt-0">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-12">
            <p>
              {{ $t('ccPage.paragraphs[0]') }}
            </p>
            <p>
              {{ $t('ccPage.paragraphs[1]') }}
            </p>
            <p>
              {{ $t('ccPage.paragraphs[2]') }}
            </p>
            <p>
              {{ $t('ccPage.paragraphs[3]') }}
            </p>
            <p>
              {{ $t('ccPage.paragraphs[4]') }}
            </p>
            <p>
              {{ $t('ccPage.paragraphs[5]') }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <footerJSK />
  </div>
</template>

<script>
import footerJSK from "./../components/footer.vue";
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";

export default {
  name: "CodeOfConduct",
  components: {
    navMenu,
    hero,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
